import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type UpdateAiReservationGroupBody = Parameters<typeof apiClient.v3.reservationGroupControllerAiUpdate>[0]

const updateAiReservationGroup = async (body: UpdateAiReservationGroupBody) => {
  const { data } = await apiClient.v3.reservationGroupControllerAiUpdate(body)
  return checkApiResponse(data)
}

export const useReservationGroupAiUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateAiReservationGroupBody> = {}) => {
  return useMutation(() => ({
    mutationFn: updateAiReservationGroup,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
